import { render } from "./InputListaSuspensa.vue?vue&type=template&id=4f1d2d6a&scoped=true"
import script from "./InputListaSuspensa.vue?vue&type=script&lang=js"
export * from "./InputListaSuspensa.vue?vue&type=script&lang=js"

import "./InputListaSuspensa.vue?vue&type=style&index=0&id=4f1d2d6a&lang=scss&scoped=true"
import "./InputListaSuspensa.vue?vue&type=style&index=1&id=4f1d2d6a&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1d2d6a"],['__file',"src/components/CampoForm/components/InputListaSuspensa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f1d2d6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f1d2d6a', __exports__)) {
    console.log('reload')
    api.reload('4f1d2d6a', __exports__)
  }
  
  module.hot.accept("./InputListaSuspensa.vue?vue&type=template&id=4f1d2d6a&scoped=true", () => {
    console.log('re-render')
    api.rerender('4f1d2d6a', render)
  })

}


export default __exports__